import React, { useEffect, useRef, useState } from "react";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { TextField, IconButton, Pagination, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { motion } from "framer-motion";
import authService from "../Auth/AuthService";
import { Add, AddCircle, CreditCard, Refresh, Tune } from "@mui/icons-material";
import TeacherList from "../view-model/TeacherList";
import ModalView from "../model/ModelView";
import TeacherRegister from "../register/TeacherRegister";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useNavigate } from "react-router-dom";
import SelectMonthYear from "../model/SelectMonthYear";
import BadgeIcon from "@mui/icons-material/Badge";
import { useMemo } from "react";

export default function TeacherViewPage(user) {
    const [teachers, setTeachers] = useState([]);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const rowsPerPage = 10;
    const hasFetched = useRef(false);
    const [empIds, setIds] = useState([]);
    const navigate = useNavigate();
    const [salarySlip, setSalarySlip] = useState(false);
    const DOC_URL = authService.DOC_URL
    const [open, setOpen] = useState(false);
    // const [editing, setEditing] = useState(null);
    // const [form, setForm] = useState({ name: "", subject: "", className: "" });

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;
        loadTeacher();
    }, []);

    const loadTeacher = async () => {
        try {
            const url = authService.pathUrl('GET', `/employees/school/${user?.user?.mas_code}`);
            const data = await authService.getAuth(url);
            setTeachers(data || []);
        } catch (error) {
            console.error("Error fetching teacher:", error);
        }
    };

    const filtered = Array.isArray(teachers)
        ? teachers.filter((t) => {
            const searchText = search.trim().toLowerCase();

            if (!searchText) return true;

            const firstName = t?.firstName?.toLowerCase() || "";
            const lastName = t?.lastName?.toLowerCase() || "";
            const fullName = `${firstName} ${lastName}`;

            return (
                firstName.includes(searchText) ||
                lastName.includes(searchText) ||
                fullName.includes(searchText)
            );
        })
        : [];

    const paginated = filtered.slice((page - 1) * rowsPerPage, page * rowsPerPage);

    // CRUD Dialog State

    const openAdd = () => {
        // setEditing(null);
        // setForm({ name: "", subject: "", className: "" });
        setOpen(true);
    };

    // const openEdit = (t) => {
    //     setEditing(t);
    //     setForm({ name: t.name, subject: t.subject, className: t.className });
    //     setOpen(true);
    // };

    // const handleDelete = (id) => {
    //     setTeachers((p) => p.filter((x) => x.id !== id));
    // };

    useEffect(() => {
        setPage(1);
    }, [search]);

    const handleClose = () => {
        setOpen(false);
        setSalarySlip(false)
    };

    const errorMsg = () => {
        const msg = {
            icon: 'warning',
            title: 'Warning',
            text: "Select minimum one employee",
        }
        authService.showSwal(msg);
    }

    const generateSalarySlip = async (month, year) => {
        console.log(month, year);

        try {
            // GET /api/salary/slip?empId=12&month=March&year=2025
            const url = authService.pathUrl('POST', `/salary/generate/bulk?empIds=${empIds}&month=${month}&year=${year}`);
            const res = await authService.postAuth(url);
            console.log(res);
        } catch (error) {
            console.error("Error fetching schools:", error);
        }
    };

    const viewSalarySlip = () => {
        navigate('/salary-slip-bulk', {
            state: {
                empIds: empIds
            },
        });
    }

    const filteredEmployees = useMemo(() => {
        return teachers.filter(employee => empIds.includes(employee.id));
    }, [teachers, empIds]);

    // function toTitleCase(str) {
    //     return str
    //         .split(" ")
    //         .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    //         .join(" ");
    // }

    const handleOpenIDcard = () => {
        navigate('/employee-card', {
            state: {
                employees: filteredEmployees.map(d => ({
                    ...d,
                    photo: d.photo !== null ? DOC_URL + d.photo : null
                }))
            },
        });
    };

    // const handleSubmit = () => {
    //     if (editing) {
    //         setTeachers((prev) => prev.map((x) => (x.id === editing.id ? { ...editing, ...form } : x)));
    //     } else {
    //         setTeachers((prev) => [...prev, { id: prev.length + 1, ...form }]);
    //     }
    //     setOpen(false);
    // };

    return (
        <div style={{ padding: 20 }}>
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="p-6 grid gap-6">
                <Card className="shadow-xl rounded-2xl p-4">
                    <CardContent>
                        <Box display={'flex'} justifyContent={'space-between'}>
                            <Typography variant="h5" gutterBottom fontWeight="bold" color="#1b1914">Teacher Details</Typography>
                            <Grid container spacing={2}>
                                <IconButton title="Refresh Page"
                                    color="warning"
                                    onClick={() => loadTeacher()}>
                                    <Refresh sx={{ border: "2px solid", fontWeight: "bold", borderRadius: "10px" }} />
                                </IconButton>

                                <IconButton
                                    title="Create ID Cards"
                                    color="warning"
                                    onClick={() => empIds.length === 0 ? errorMsg() : handleOpenIDcard()}
                                >
                                    <BadgeIcon sx={{ border: "2px solid", fontWeight: "bold", borderRadius: "10px" }} />
                                </IconButton>
                                <IconButton
                                    color="warning"
                                    onClick={() => empIds.length === 0 ? errorMsg() : setSalarySlip(true)}
                                    title="Genrate Salary"
                                >
                                    <CreditCard sx={{ border: "2px solid", fontWeight: "bold", borderRadius: "10px" }} />
                                </IconButton>
                                <IconButton
                                    color="warning"
                                    onClick={() => empIds.length === 0 ? errorMsg() : viewSalarySlip()}
                                    title="View Salary"
                                >
                                    <PictureAsPdfIcon sx={{ border: "2px solid", fontWeight: "bold", borderRadius: "10px" }} />
                                </IconButton>

                                <IconButton
                                    color="warning"
                                    onClick={() => openAdd()}
                                    title="Add Teacher"
                                >
                                    <Add sx={{ border: "2px solid", fontWeight: "bold", borderRadius: "10px" }} />
                                </IconButton>
                            </Grid>
                        </Box>
                        <TextField
                            variant="outlined"
                            placeholder="Search by first name, last name"
                            fullWidth
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    )
                                }
                            }}
                            sx={{ mb: 3 }}
                        />
                        <TeacherList teachers={paginated} setIds={setIds} />

                        <div className="flex justify-center mt-4">
                            <Pagination
                                count={Math.ceil(filtered.length / rowsPerPage)}
                                page={page}
                                onChange={(e, v) => setPage(v)}
                            />
                        </div>

                        {/* <TableContainer component={Paper} className="rounded-2xl shadow-md">
                        <Table>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                                    <TableCell><strong>ID</strong></TableCell>
                                    <TableCell><strong>Name</strong></TableCell>
                                    <TableCell><strong>Subject</strong></TableCell>
                                    <TableCell><strong>Class</strong></TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {paginated.length > 0 ? (
                                    paginated.map((t) => (
                                        <TableRow key={t.id} hover>
                                            <TableCell>{t.id}</TableCell>
                                            <TableCell>{t.name}</TableCell>
                                            <TableCell>{t.subject}</TableCell>
                                            <TableCell>{t.className}</TableCell>
                                            <TableCell>
                                                <button onClick={() => openEdit(t)} className="text-blue-600 mr-3">Edit</button>
                                                <button onClick={() => handleDelete(t.id)} className="text-red-600">Delete</button>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">No teachers found</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer> */}

                        {/* <div className="flex justify-center mt-4">
                        <Pagination
                            count={Math.ceil(filtered.length / rowsPerPage)}
                            page={page}
                            onChange={(e, v) => setPage(v)}
                        />
                    </div> */}
                        {/* CRUD Dialog */}
                        {/* {open && (
                            <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center">
                                <div className="bg-white p-6 rounded-2xl shadow-xl w-96">
                                    <h2 className="text-xl font-bold mb-4">{editing ? "Edit Teacher" : "Add Teacher"}</h2>

                                    <TextField
                                        label="Teacher Name"
                                        fullWidth
                                        value={form.name}
                                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                                        sx={{ mb: 2 }}
                                    />
                                    <TextField
                                        label="Subject"
                                        fullWidth
                                        value={form.subject}
                                        onChange={(e) => setForm({ ...form, subject: e.target.value })}
                                        sx={{ mb: 2 }}
                                    />
                                    <TextField
                                        label="Class"
                                        fullWidth
                                        value={form.className}
                                        onChange={(e) => setForm({ ...form, className: e.target.value })}
                                        sx={{ mb: 3 }}
                                    />

                                    <div className="flex justify-end gap-3">
                                        <button
                                            onClick={() => setOpen(false)}
                                            className="px-4 py-2 rounded-xl bg-gray-300 hover:bg-gray-400"
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            onClick={handleSubmit}
                                            className="px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700"
                                        >
                                            {editing ? "Update" : "Add"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )} */}

                    </CardContent>
                </Card>
            </motion.div>

            <ModalView
                size="md"
                open={open}
                handleClose={handleClose}
                title="Add Employee"
                content={
                    <TeacherRegister
                        onSuccess={() => setOpen(false)}
                    />
                }
            />
            <ModalView
                size="sm"
                open={salarySlip}
                handleClose={handleClose}
                title="Generate Salary"
                content={
                    <SelectMonthYear
                        onSuccess={(month, year) => {
                            setSalarySlip(false);
                            generateSalarySlip(month, year);
                        }}
                    />
                }
            />
        </div>
    );
}
